import { useState, memo } from 'react'
import { useNavigate } from 'react-router-dom'
import { styled } from '@mui/material/styles'
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp'
import MuiAccordion, { AccordionProps } from '@mui/material/Accordion'
import MuiAccordionSummary, {
	AccordionSummaryProps,
} from '@mui/material/AccordionSummary'
import MuiAccordionDetails from '@mui/material/AccordionDetails'
import Typography from '@mui/material/Typography'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import DashboardIcon from '@mui/icons-material/Dashboard'
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts'
import SettingsIcon from '@mui/icons-material/Settings'
import InfoIcon from '@mui/icons-material/Info'
import IntegrationInstructionsIcon from '@mui/icons-material/IntegrationInstructions'
import WidgetsIcon from '@mui/icons-material/Widgets'
import NewspaperIcon from '@mui/icons-material/Newspaper'
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf'
import ScienceIcon from '@mui/icons-material/Science'
import ManageSearchIcon from '@mui/icons-material/ManageSearch'
import CoronavirusIcon from '@mui/icons-material/Coronavirus'
import HistoryIcon from '@mui/icons-material/History'
import WorkHistoryIcon from '@mui/icons-material/WorkHistory'
import SyncIcon from '@mui/icons-material/Sync'
import AutoGraphIcon from '@mui/icons-material/AutoGraph'
import TimelineIcon from '@mui/icons-material/Timeline'
import AssessmentIcon from '@mui/icons-material/Assessment'
import DataSaverOnIcon from '@mui/icons-material/DataSaverOn'
import BubbleChartIcon from '@mui/icons-material/BubbleChart'
import BloodtypeIcon from '@mui/icons-material/Bloodtype'
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn'
import BugReportIcon from '@mui/icons-material/BugReport'
import SummarizeIcon from '@mui/icons-material/Summarize'
import ScreenSearchDesktopIcon from '@mui/icons-material/ScreenSearchDesktop'
import SmsIcon from '@mui/icons-material/Sms'
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn'
import ReceiptIcon from '@mui/icons-material/Receipt'
import PaymentIcon from '@mui/icons-material/Payment'
import PhoneIcon from '@mui/icons-material/Phone'
import MarkUnreadChatAltIcon from '@mui/icons-material/MarkUnreadChatAlt'
import BiotechIcon from '@mui/icons-material/Biotech'
import DownloadingIcon from '@mui/icons-material/Downloading'
import ContentPasteIcon from '@mui/icons-material/ContentPaste'
import FileDownloadIcon from '@mui/icons-material/FileDownload'
import DownloadIcon from '@mui/icons-material/Download'
import PublishIcon from '@mui/icons-material/Publish'
import PrintIcon from '@mui/icons-material/Print'
import MediationIcon from '@mui/icons-material/Mediation'
import SendIcon from '@mui/icons-material/Send'
import GroupsIcon from '@mui/icons-material/Groups'
import ScheduleSendIcon from '@mui/icons-material/ScheduleSend'
import ListAltIcon from '@mui/icons-material/ListAlt'
import PlaylistAddCheckCircleIcon from '@mui/icons-material/PlaylistAddCheckCircle'
import ImportContactsIcon from '@mui/icons-material/ImportContacts'
import AllInboxIcon from '@mui/icons-material/AllInbox'
import PhoneLockedIcon from '@mui/icons-material/PhoneLocked'
import MessageIcon from '@mui/icons-material/Message'
import CodeIcon from '@mui/icons-material/Code'
import MuseumIcon from '@mui/icons-material/Museum'
import HistoryEduIcon from '@mui/icons-material/HistoryEdu'
import InterestsIcon from '@mui/icons-material/Interests'
import PeopleAltIcon from '@mui/icons-material/PeopleAlt'
import HelpCenterIcon from '@mui/icons-material/HelpCenter'
import TheaterComedyIcon from '@mui/icons-material/TheaterComedy'
import PollIcon from '@mui/icons-material/Poll'
import PermPhoneMsgIcon from '@mui/icons-material/PermPhoneMsg'
import LocalShippingIcon from '@mui/icons-material/LocalShipping'
import WatchIcon from '@mui/icons-material/Watch'
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer'
import BallotIcon from '@mui/icons-material/Ballot'
import FavoriteIcon from '@mui/icons-material/Favorite'
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser'
import DragIndicatorIcon from '@mui/icons-material/DragIndicator'

import { TempElementItem } from '../constants/types'

import { useDispatch, useSelector } from 'react-redux'
import { ThemeProvider } from '@mui/material/styles'
import { useTheme } from '@mui/material/styles'
import { darkTheme, lightTheme } from '../constants/defaultValues'
import { selectDisplayMode } from 'hooks/themeMode'

import { useMediaQuery } from '@mui/material'
import { selectuserInfo } from 'hooks/userInfo'
import { setPos1, setPos2 } from 'hooks/pagePos'
import React from 'react'

/**
 * 아코디언 아이콘 설정
 */
type IconType = {
	menuName: string
	menuIcon: keyof typeof icons
	//iconStr: (props: SvgIconProps) => JSX.Element
}
const icons = {
	DashboardIcon,
	ManageAccountsIcon,
	SettingsIcon,
	IntegrationInstructionsIcon,
	InfoIcon,
	WidgetsIcon,
	NewspaperIcon,
	PictureAsPdfIcon,
	ScienceIcon,
	ManageSearchIcon,
	HistoryIcon,
	CoronavirusIcon,
	WorkHistoryIcon,
	SyncIcon,
	AutoGraphIcon,
	TimelineIcon,
	AssessmentIcon,
	DataSaverOnIcon,
	BubbleChartIcon,
	BloodtypeIcon,
	AssignmentTurnedInIcon,
	BugReportIcon,
	SummarizeIcon,
	ScreenSearchDesktopIcon,
	SmsIcon,
	MonetizationOnIcon,
	ReceiptIcon,
	PaymentIcon,
	PhoneIcon,
	MarkUnreadChatAltIcon,
	BiotechIcon,
	DownloadingIcon,
	ContentPasteIcon,
	FileDownloadIcon,
	DownloadIcon,
	PublishIcon,
	PrintIcon,
	MediationIcon,
	SendIcon,
	GroupsIcon,
	ScheduleSendIcon,
	ListAltIcon,
	PlaylistAddCheckCircleIcon,
	ImportContactsIcon,
	AllInboxIcon,
	PhoneLockedIcon,
	MessageIcon,
	CodeIcon,
	MuseumIcon,
	HistoryEduIcon,
	InterestsIcon,
	PeopleAltIcon,
	HelpCenterIcon,
	TheaterComedyIcon,
	PollIcon,
	PermPhoneMsgIcon,
	LocalShippingIcon,
	WatchIcon,
	QuestionAnswerIcon,
	BallotIcon,
	FavoriteIcon,
	VerifiedUserIcon,
	DragIndicatorIcon,
}

const Accordion = styled((props: AccordionProps) => (
	<MuiAccordion
		disableGutters
		elevation={0}
		square
		{...props}
	/>
))(({ theme }) => ({
	border: `1px solid ${theme.palette.divider}`,
	'&:not(:last-child)': {
		borderBottom: 0,
	},
	'&:before': {
		display: 'none',
	},
}))

const AccordionSummary = styled((props: AccordionSummaryProps) => (
	<MuiAccordionSummary
		expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
		{...props}
	/>
))(({ theme }) => ({
	backgroundColor:
		theme.palette.mode === 'dark'
			? 'rgba(255, 255, 255, .05)'
			: 'rgba(0, 0, 0, .03)',
	flexDirection: 'row-reverse',
	'& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
		transform: 'rotate(90deg)',
	},
	'& .MuiAccordionSummary-content': {
		marginLeft: theme.spacing(1),
	},
}))

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
	padding: theme.spacing(2),
	borderTop: '1px solid rgba(0, 0, 0, .125)',
}))

/**
 * 좌측 메뉴바
 * @param param0
 * @returns
 */
const Gnb = ({ menuList, open, handleDrawerClose }: any) => {
	const theme = useTheme()
	const navigate = useNavigate()
	const dispatch = useDispatch()
	const themeMode = useSelector(selectDisplayMode)

	const userInfo = useSelector(selectuserInfo)

	// const gnbToggle = useSelector(selectGnbToggle)
	const isMdUp = useMediaQuery(theme.breakpoints.up('md'))

	const [expanded, setExpanded] = useState<string | false>('panel_0')
	const [nowMenu, setNowMenu] = useState(
		userInfo?.infoType === 'C' ? '/admin/test/result' : '/admin/dashboard'
	)

	/**
	 * 아코디언 toggle
	 * @param panel
	 * @returns
	 */
	const handleChange =
		(panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
			setExpanded(newExpanded ? panel : false)
		}

	/**
	 * 아이콘 지정
	 * @param item
	 * @returns
	 */
	const getIcon = (item: TempElementItem) => {
		const convertedIcon = item as IconType
		const Icon = icons[convertedIcon.menuIcon]
		return <Icon />
	}

	/**
	 * 페이지 이동
	 * @param {*} e : 클릭한 대상 , parent : 부모 level
	 */
	const pageMove = (
		e: { menuName: string; menuLink: string },
		parent: string,
		panelName: string
	) => {
		// console.log(e.menuName, e.menuLink, parent, panelName)
		// if (!isMdUp) {
		// 	dispatch(setGnbToggle(false))
		// }
		// dispatch(setGnbToggle(false))
		dispatch(setPos1({ title: parent, link: '' }))
		dispatch(setPos2({ title: e.menuName, link: e.menuLink }))
		setNowMenu(e.menuLink)
		navigate(e.menuLink)
		// accordion expand 처리
		//setExpanded(panelName)
		setExpanded(panelName)
		// console.log('page move')
		// console.log(e.menuName, e.menuLink, parent, panelName)
		// console.log(nowMenu)
	}

	return (
		menuList &&
		menuList.map((item: TempElementItem, index: number) => {
			return (
				<ThemeProvider
					key={item.id}
					theme={themeMode.isDarkMode ? darkTheme : lightTheme}
				>
					<Accordion
						expanded={expanded === `panel_${index}`}
						//expanded={true}
						onChange={handleChange(`panel_${index}`)}
						key={index}
						sx={{ background: themeMode.isDarkMode ? '#121212' : 'transparent' }}
					>
						{item.menuLink && item.children?.length === 0 ? (
							// 2depth 메뉴 없는 경우
							<ListItem
								disablePadding
								key={item.id}
								sx={{
									display: 'block',
									background: themeMode.isDarkMode ? '#121212' : 'transparent',
									borderBottom: '1px solid rgba(255, 255, 255, 0.12)',
								}}
							>
								<ListItemButton onClick={() => pageMove(item, '', `panel_${index}`)}>
									<ListItemIcon
										sx={{
											minWidth: 0,
											mr: 1,
											justifyContent: 'center',
											color:
												item.menuLink === nowMenu
													? themeMode.isDarkMode
														? '#fff'
														: '#fff'
													: '#fff',
										}}
									>
										{getIcon(item)}
									</ListItemIcon>
									<ListItemText
										primary={item.menuName}
										sx={{
											marginLeft: '0 !important',
											opacity: open ? 1 : 0,
											color:
												item.menuLink === nowMenu
													? themeMode.isDarkMode
														? '#fff'
														: '#fff'
													: '#fff',
										}}
									/>
								</ListItemButton>
							</ListItem>
						) : (
							// 2depth 메뉴 있는 경우
							<AccordionSummary
								aria-controls={`panel${item.id}-content`}
								id={`panel${item.id}-header`}
								sx={{
									color: themeMode.isDarkMode ? '#fff' : '#fff',
									'.MuiAccordionSummary-expandIconWrapper': {
										color: '#fff',
									},
									borderBottom: '1px solid rgba(255, 255, 255, 0.12)',
								}}
							>
								<Typography>{item.menuName}</Typography>
							</AccordionSummary>
						)}
						{item?.children?.length > 0 && (
							<AccordionDetails sx={{ padding: '0' }}>
								<List>
									{item &&
										item.children.map((i: any, j: number) => {
											return (
												<React.Fragment key={i.id}>
													<ListItem
														disablePadding
														sx={{
															display: 'block',
															pl: 2,
															borderBottom: '1px solid rgba(255, 255, 255, 0.12)',
														}}
													>
														<ListItemButton
															onClick={() => pageMove(i, item.menuName, `panel_${index}`)}
															sx={{
																minHeight: 48,
																justifyContent: open ? 'initial' : 'center',
																px: 2.5,
															}}
														>
															<ListItemIcon
																sx={{
																	minWidth: 0,
																	mr: 0,
																	justifyContent: 'center',
																	color:
																		i.menuLink === nowMenu
																			? themeMode.isDarkMode
																				? '#fff'
																				: '#fff'
																			: '#fff',
																}}
															>
																{getIcon(i)}
															</ListItemIcon>
															<ListItemText
																primary={i.menuName}
																sx={{
																	opacity: open ? 1 : 0,
																	color:
																		i.menuLink === nowMenu
																			? themeMode.isDarkMode
																				? '#fff'
																				: '#fff'
																			: '#fff',
																}}
															/>
														</ListItemButton>
													</ListItem>
												</React.Fragment>
											)
										})}
								</List>
							</AccordionDetails>
						)}
					</Accordion>
				</ThemeProvider>
			)
		})
	)
}

export default memo(Gnb)
